export default __webpack_public_path__ + "static/media/playback-speed-icon.30b1b8fd.svg";